export default "__VITE_ASSET__ZtYBvsXw__"